export const capitalizeText = (text: string) => {
  // Capitalizing the first letter of each word
  return text
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
